<template>
    <div class="wrap">
      <el-card class="box-card stockCard" shadow="never">
        <el-row>
          <el-col :span="8">
            <div class="stockIndex">
              <div class="stockImg">
                <!-- <router-link :to="{name:'Stockdetailed',query:{symbol:'usDJI'}}"> -->
                  <el-image src="//image.sinajs.cn/newchart/png/min/us/dji.png"
                            style="width: 85%"></el-image>
                <!-- </router-link> -->
              </div>
              <p class="stockUp" v-if="indexDetail.changepercent[0]">
                <!-- <router-link :to="{name:'Stockdetailed',query:{symbol:'usDJI'}}"> -->
                  {{ $t('pc.quotes.stock_rise1') }}
                <!-- </router-link> -->
                <span class="red" v-if="indexDetail.changepercent[0].substr(0,1) === '+'">{{ indexDetail.trade[0] }} {{ indexDetail.changepercent[0] }}% <span v-if="indexDetail.marketCapitalization[0] > 0">{{ indexDetail.marketCapitalization[0] }}亿元</span></span>
                <span class="green" v-else>{{ indexDetail.trade[0] }} {{ indexDetail.changepercent[0] }}% <span v-if="indexDetail.marketCapitalization[0] > 0">{{ indexDetail.marketCapitalization[0] }}{{$t('pc.stockrise.currency')}}</span></span>
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stockIndex">
              <div class="stockImg">
                <!-- <router-link :to="{name:'Stockdetailed',query:{symbol:'usINX'}}"> -->
                  <el-image src="https://image.sinajs.cn/newchart/png/min/us/inx.png"
                            style="width: 85%"></el-image>
                <!-- </router-link> -->
              </div>
              <p class="stockUp" v-if="indexDetail.changepercent[1]">
                <!-- <router-link :to="{name:'Stockdetailed',query:{symbol:'usINX'}}"> -->
                  {{ $t('pc.quotes.stock_rise2') }}
                <!-- </router-link> -->
                <span class="red" v-if="indexDetail.changepercent[1].substr(0,1) === '+'">{{ indexDetail.trade[1] }} {{ indexDetail.changepercent[1] }}% <span v-if="indexDetail.marketCapitalization[1] > 0">{{ indexDetail.marketCapitalization[1] }}亿元</span></span>
                <span class="green" v-else>{{ indexDetail.trade[1] }} {{ indexDetail.changepercent[1] }}% <span v-if="indexDetail.marketCapitalization[1] > 0">{{ indexDetail.marketCapitalization[1] }}{{$t('pc.stockrise.currency')}}</span></span>
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stockIndex">
              <div class="stockImg">
                <!-- <router-link :to="{name:'Stockdetailed',query:{symbol:'usIXIC'}}"> -->
                  <el-image src="//image.sinajs.cn/newchart/png/min/us/ixic.png"
                            style="width: 85%"></el-image>
                <!-- </router-link> -->
              </div>
              <p class="stockUp" v-if="indexDetail.changepercent[2]">
                <!-- <router-link :to="{name:'Stockdetailed',query:{symbol:'usIXIC'}}"> -->
                  {{ $t('pc.quotes.stock_rise3') }}
                <!-- </router-link> -->
                <span class="red" v-if="indexDetail.changepercent[2].substr(0,1) === '+'">{{ indexDetail.trade[2] }} {{ indexDetail.changepercent[2] }}% <span v-if="indexDetail.marketCapitalization[2] > 0">{{ indexDetail.marketCapitalization[2] }}亿元</span></span>
                <span class="green" v-else>{{ indexDetail.trade[2] }} {{ indexDetail.changepercent[2] }}% <span v-if="indexDetail.marketCapitalization[2] > 0">{{ indexDetail.marketCapitalization[2] }}{{$t('pc.stockrise.currency')}}</span></span>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
</template>

<script>
  import $ from "jquery";
    export default {
      name: "stockrise",
      data() {
        return {
          tableData: [],
          indexDetail:{
            trade:[],
            changepercent: [],
            marketCapitalization: []
          },
          total:3809,//默认数据总数
          pagesize:15,//每页的数据条数
          currentPage:1,//默认开始页面
          currentLang: "en",
        };
      },
      methods: {
        getIndexData(){
          let that = this;
          let shortArr = ['usDJI','usINX','usIXIC'];
          let currentLanguage = this.currentLang;
          $.ajax({
            url: "https://qt.gtimg.cn/q="+ shortArr.toString(),
            type: "GET",
            dataType: "script",
            cache: true,
            success: function() {
              var i, elements;
              let indexDetail = {trade:[],changepercent:[],marketCapitalization:[]};
              for (i = 0; i < shortArr.length; i++) {
                var elements = eval("v_" + shortArr[i]).split("~");
                indexDetail.trade.push(elements[3]);
                if(elements[32].substr(0,1) === '-'){
                  indexDetail.changepercent.push(elements[32]);
                }else{
                  indexDetail.changepercent.push('+'+elements[32]);
                }
                if(currentLanguage === "zh"){
                  indexDetail.marketCapitalization.push((parseInt(elements[37]) / 1000).toFixed(2));
                }
                else if(currentLanguage === "en"){
                  indexDetail.marketCapitalization.push((parseInt(elements[37]) / 10000).toFixed(2));
                }
               
              }
              that.indexDetail = indexDetail;
            }
          });
        },
        getTableCount(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'stock_count',
            }
          })  .then(ret => {
            let resData = ret.data;
            if (resData.code === 1){
               this.total = parseInt(resData.data.count);
            }else{
              that.$alert('请稍后尝试','提示',{
                confirmButtonText: '确定',
                callback: action => that.getTableCount()
              })
            }
          });
        },
        getTableData(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'stockchange',
              'page': this.currentPage,
              'asc': 0,
              'num':15
            }
          })  .then(ret => {
            let resData = ret.data;
            if (resData.code === 1){
              this.tableData = resData.data;
            }else{
              that.$alert('请稍后尝试','提示',{
                confirmButtonText: '确定',
                callback: action => that.getTableData()
              })
            }
          });
        },
        //页码变更
        handleCurrentChange(currentPage) {
         this.currentPage = currentPage;
         this.getTableData();
        }
      },
      mounted: function () {
        let that = this;
        this.currentLang = localStorage.getItem("locale") || "en";
        this.getIndexData();
        this.chatTimer = setInterval(function () {
          that.getIndexData();
        },10000);
        this.getTableCount();
        this.getTableData();
      },
      beforeDestroy() {
        clearTimeout(this.chatTimer);
      }
    }
</script>

<style scoped>
  .stockIndex {
    margin: 0 auto;
    text-align: center;
  }

  .stockCard {
  }

  .stockImg {
    margin: 0 auto;
  }

  .stockUp {
    line-height: 24px;
    font-size: 12px;
    width: 85%;
    height: 24px;
    background: #f3f3f5;
    text-align: center;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space: nowrap;/*加宽度width属来兼容部分浏览*/
    margin: 10px auto 0;
  }
  .main {
    margin-top: 10px;
  }
  .stockLinkColor{
    color: rgb(0,0,238);
  }
  .stockLinkColor :hover{
    color: #0100A0;
  }
  .green{
    color: #008000;
  }
  .wrap{
  }

  .pagination{
    margin: 0 auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/stockrise.vue